import * as React from "react"

export type Context = {
  isMenuOpen: boolean
  setIsMenuOpen: (isMenuOpen: boolean) => void
}

const Context = React.createContext<Context>({
  isMenuOpen: false,
  setIsMenuOpen: () => {}
})

const useShellContext = () => React.use(Context)

export const ShellContext = {
  Provider: Context.Provider,
  useContext: useShellContext
}
